import { render } from "./commonTable.vue?vue&type=template&id=1f0bea9b&scoped=true"
import script from "./commonTable.vue?vue&type=script&lang=js"
export * from "./commonTable.vue?vue&type=script&lang=js"

import "./commonTable.vue?vue&type=style&index=0&id=1f0bea9b&lang=less&scoped=true"

import exportComponent from "D:\\work_zfb\\zoudulaocheng\\web-zdlc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0bea9b"]])

export default __exports__